import { render, staticRenderFns } from "./DataPrivacyNotice.vue?vue&type=template&id=44b16164&scoped=true&"
import script from "./DataPrivacyNotice.vue?vue&type=script&lang=ts&"
export * from "./DataPrivacyNotice.vue?vue&type=script&lang=ts&"
import style0 from "./DataPrivacyNotice.vue?vue&type=style&index=0&id=44b16164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b16164",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSheet})
